<template>
  <c-button
    class="q-btn--menu"
    v-bind="$attrs"
    :icon-right="iconRight ?? buttonIcon"
  >
    <c-menu
      v-model="showMenu"
      v-bind="menuOptions"
      :offset="menuOffset"
      @hide="emit('hide')"
      @show="emit('show')"
      @before-show="
        backdrop && showBackdrop();
        emit('before-show');
      "
      @before-hide="
        backdrop && hideBackdrop();
        emit('before-hide');
      "
    >
      <slot />
    </c-menu>
  </c-button>
</template>

<script setup>
import { computed, ref } from "vue";
import { useBackdrop } from "composables/useBackdrop.js";
import CButton from "shared/components/wrappers/button/CButton.vue";

const { showBackdrop, hideBackdrop } = useBackdrop();

const emit = defineEmits(["hide", "show", "before-show", "before-hide"]);
const showMenu = ref(false);

const buttonIcon = computed(() => {
  return [
    "fa-solid",
    "fa-chevron-down",
    ...(showMenu.value ? ["fa-flip-vertical"] : []),
  ].join(" ");
});

defineProps({
  // Replaces the flipping chevron, e.g. with an ellipsis for a row's actions.
  iconRight: {
    type: String,
    default: null,
  },
  menuOptions: {
    type: Object,
    required: false,
  },
  backdrop: {
    type: Boolean,
    default: false,
  },
  menuOffset: {
    type: Array,
    default: () => [0, 0],
  },
});
</script>

<style lang="scss">
button.q-btn.q-btn--menu {
  .q-btn__content {
    > .q-icon {
      @apply tw-text-[14px] tw-transition tw-duration-300;
    }
  }
}
</style>
